import { Component, OnInit } from '@angular/core';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { ApiService } from './../../shared/services/api.service';
import { CommunicationService } from './../../shared/services/communication.service';
import { EstateAgent } from './../../models/real-estates/real-estates.model';

@Component({
  selector: 'swb-estate-agents-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class EstateAgentsListComponent extends ListBase<EstateAgent> implements OnInit {

  public url = 'estate-agents';
  public routePrefix = 'estate-agents';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
